import { useState } from "react";
import { AddService } from "./add-service-dialog";
import { EditServiceDialog } from "./edit-service-dialog";
import { DeleteServiceDialog } from "./delete-service-dialog";
import ServicesTable from "./services-table";
import type { Service } from "@/types/services/api-types/service-types";

export const ServicesTabContent = () => {
  const [selectedService, setSelectedService] = useState<Service | null>(null);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [serviceToDelete, setServiceToDelete] = useState<Service | null>(null);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);

  const handleServiceClick = (service: Service) => {
    setSelectedService(service);
    setIsEditDialogOpen(true);
  };

  const handleEditDialogClose = (open: boolean) => {
    setIsEditDialogOpen(open);
    if (!open) {
      setSelectedService(null);
    }
  };

  const handleDeleteClick = (service: Service) => {
    setServiceToDelete(service);
    setIsDeleteDialogOpen(true);
  };

  const handleDeleteDialogClose = (open: boolean) => {
    setIsDeleteDialogOpen(open);
    if (!open) {
      setServiceToDelete(null);
    }
  };

  return (
    <div className="mt-5">
      <div className="flex justify-end mb-4 pr-4">
        <AddService />
      </div>
      <ServicesTable
        onServiceClick={handleServiceClick}
        onDeleteClick={handleDeleteClick}
      />
      {selectedService && (
        <EditServiceDialog
          service={selectedService}
          open={isEditDialogOpen}
          onOpenChange={handleEditDialogClose}
        />
      )}
      {serviceToDelete && (
        <DeleteServiceDialog
          service={serviceToDelete}
          open={isDeleteDialogOpen}
          onOpenChange={handleDeleteDialogClose}
        />
      )}
    </div>
  );
};
